var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppleBundlesCorporateService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11158_7270)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11158_7270",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -2,
    width: 41,
    height: 41
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.674805 -1.68799H40.6748V38.312H0.674805V-1.68799Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11158_7270)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M26.543 3.77301H29.293V35.856H26.543V3.77301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1748 28.88L30.2588 29.027M13.4248 36.312H25.5898C26.6507 36.312 27.6681 35.8906 28.4182 35.1404C29.1684 34.3903 29.5898 33.3729 29.5898 32.312V7.31201C29.5898 6.25115 29.1684 5.23373 28.4182 4.48358C27.6681 3.73344 26.6507 3.31201 25.5898 3.31201H13.4238C12.3629 3.31201 11.3455 3.73344 10.5954 4.48358C9.84523 5.23373 9.4238 6.25115 9.4238 7.31201V32.312C9.4238 33.3729 9.84523 34.3903 10.5954 35.1404C11.3455 35.8906 12.3629 36.312 13.4238 36.312H13.4248Z",
    stroke: "#76BC21",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6626 34.086C20.422 34.086 21.0376 33.4704 21.0376 32.711C21.0376 31.9516 20.422 31.336 19.6626 31.336C18.9032 31.336 18.2876 31.9516 18.2876 32.711C18.2876 33.4704 18.9032 34.086 19.6626 34.086Z",
    fill: "#76BC21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5429 5.98804H18.3359C17.956 5.98804 17.6479 6.29584 17.6479 6.67554C17.6479 7.05523 17.956 7.36304 18.3359 7.36304H21.5429C21.9229 7.36304 22.2309 7.05523 22.2309 6.67554C22.2309 6.29584 21.9229 5.98804 21.5429 5.98804Z",
    fill: "#76BC21"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7947 25.128C12.9692 25.128 15.0547 24.2642 16.5923 22.7265C18.1299 21.1889 18.9937 19.1035 18.9937 16.929C18.9937 14.7545 18.1299 12.669 16.5923 11.1314C15.0547 9.5938 12.9692 8.72998 10.7947 8.72998C8.62019 8.72998 6.53475 9.5938 4.99713 11.1314C3.45952 12.669 2.5957 14.7545 2.5957 16.929C2.5957 19.1035 3.45952 21.1889 4.99713 22.7265C6.53475 24.2642 8.62019 25.128 10.7947 25.128Z",
    fill: "#76BC21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7268 22.456C12.2154 22.456 13.6431 21.8646 14.6958 20.812C15.7484 19.7593 16.3398 18.3316 16.3398 16.843C16.3398 15.3543 15.7484 13.9266 14.6958 12.874C13.6431 11.8213 12.2154 11.23 10.7268 11.23C9.23811 11.23 7.81042 11.8213 6.75778 12.874C5.70514 13.9266 5.11377 15.3543 5.11377 16.843C5.11377 18.3316 5.70514 19.7593 6.75778 20.812C7.81042 21.8646 9.23811 22.456 10.7268 22.456Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7269 22.456C12.3809 22.456 13.7219 19.943 13.7219 16.843C13.7219 13.743 12.3809 11.23 10.7269 11.23C9.07293 11.23 7.73193 13.743 7.73193 16.843C7.73193 19.943 9.07293 22.456 10.7269 22.456Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29977 13.398C7.32577 14.102 8.92677 14.554 10.7268 14.554C12.5268 14.554 14.1278 14.102 15.1548 13.398M6.74477 20.533C7.68977 19.656 9.16477 19.093 10.8228 19.093C12.4798 19.093 13.9548 19.656 14.9008 20.533M10.7268 11.23V22.456M5.11377 16.844H16.3398",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9758 31.435C35.5048 31.435 39.1758 27.671 39.1758 23.026C39.1758 18.382 35.5048 14.617 30.9758 14.617C26.4478 14.617 22.7778 18.382 22.7778 23.027C22.7778 27.67 26.4478 31.435 30.9758 31.435Z",
    fill: "#76BC21"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0085 22.681V27.846L35.2825 27.449L34.3095 26.922H30.1175C29.4675 26.922 28.9355 26.395 28.9355 25.739V23.729H31.7135C32.0095 23.729 32.2785 23.611 32.4775 23.417C32.6875 23.218 32.8105 22.944 32.8105 22.633V21.503H34.8265C35.4765 21.503 36.0085 22.031 36.0085 22.681Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7527 20.262H31.0317M27.7527 21.781H31.0317M32.8097 18.71V22.553C32.8097 23.203 32.2837 23.73 31.6337 23.73H27.4397L25.7417 24.655V19.49C25.7417 18.84 26.2687 18.313 26.9187 18.313H32.4167C32.6317 18.313 32.8097 18.49 32.8097 18.705V18.71Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11158_7270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleBundlesCorporateService);
export default __webpack_public_path__ + "static/media/appleBundlesCorporateService.6486d725bbe8cd3c781a62fcb2507bca.svg";
export { ForwardRef as ReactComponent };